import React from 'react';
import './IntroductionSection.css';
import { FaCheckCircle, FaStar, FaUsers, FaAward, FaClock, FaShieldAlt } from 'react-icons/fa';
import neatImage from '../../assets/neat.png';
import { useAppSelector } from '../../store/hooks';

const IntroductionSection = () => {
  const stats = useAppSelector((state) => state.stats);
  
  return (
    <section className="introduction-section">
      <div className="introduction-container">
        <div className="introduction-image">
          <div className="image-container">
            <img 
              src={neatImage} 
              alt="NeatnClean Storefront - Professional laundry service with employees and equipment" 
              className="storefront-image"
            />
          </div>
        </div>
        
        <div className="introduction-content">
          <div className="content-header">
            <h2>Welcome to <span className="brand-highlight">NeatnClean</span></h2>
            <p className="subtitle">India's Most Trusted Laundry & Dry Cleaning Service</p>
          </div>
          
          <div className="content-body">
            <p className="main-description">
              At NeatnClean, we've revolutionized the way India does laundry. With over <strong>{stats.customerCount.toLocaleString()}+ satisfied customers</strong> and <strong>99.8% satisfaction rate</strong>, we bring professional-grade cleaning right to your doorstep.
            </p>
            
            {/* <div className="highlight-points">
              <div className="highlight-item">
                <div className="highlight-icon">
                  <FaCheckCircle />
                </div>
                <div className="highlight-text">
                  <h4>Professional Quality</h4>
                  <p>State-of-the-art equipment and expert techniques ensure your clothes look brand new every time.</p>
                </div>
              </div>
              
              <div className="highlight-item">
                <div className="highlight-icon">
                  <FaClock />
                </div>
                <div className="highlight-text">
                  <h4>24/7 Service</h4>
                  <p>Round-the-clock pickup and delivery service that fits perfectly into your busy schedule.</p>
                </div>
              </div>
              
              <div className="highlight-item">
                <div className="highlight-icon">
                  <FaShieldAlt />
                </div>
                <div className="highlight-text">
                  <h4>100% Safe & Secure</h4>
                  <p>Your garments are handled with utmost care and security throughout the entire process.</p>
                </div>
              </div>
            </div>
            
            <div className="stats-row">
              <div className="stat-item">
                <div className="stat-number">50K+</div>
                <div className="stat-label">Happy Customers</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">99.8%</div>
                <div className="stat-label">Satisfaction Rate</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Service Available</div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionSection;
